import { client } from '@api/client';
import { URL } from '@api/urls';

import { IAssetTypeSubtypeResponse } from '@interfaces/assets/asset';
import { IItemsResponse } from '@interfaces/common/response';
import { IApprovalUnit } from '@interfaces/organisation/approvalUnits';
import { TAssignmentUnit } from '@interfaces/organisation/assignApprovalUnits';
import {
	IAssignmentApprovalUnitDTO,
	IAttachedApprovalUnitDTO,
	IUnitId,
	IUpdateAssignmentApprovalUnitDTO,
} from '@interfaces/organisation/dto/approvalUnitsDTO';

const {
	attachedApprovalUnit,
	attachedApprovalUnitUsers,
	attachedTypesSubTypes,
	approvalUnitsOptions,
} = URL;

export const getDropdownFilterApprovalUnits = (): Promise<IApprovalUnit[]> => {
	return client.get(`${attachedApprovalUnit}/${attachedApprovalUnitUsers}`);
};

export const getDropdownAssetsAttached = (): Promise<IAssetTypeSubtypeResponse[]> => {
	return client.get(`${attachedApprovalUnit}/${attachedTypesSubTypes}`);
};

export const getAssignedApprovalUnits = (data: IAttachedApprovalUnitDTO): Promise<IItemsResponse<TAssignmentUnit>> => {
	return client.get(`${attachedApprovalUnit}/filter`, {
		params: {
			...data,
		},
	});
};

export const getAvailableApprovalUnits = (): Promise<IApprovalUnit[]> => client.get(approvalUnitsOptions);

export const createAssigmentApprovalUnit = (data: IAssignmentApprovalUnitDTO): Promise<void> => {
	return client.post(attachedApprovalUnit, data);
};

export const updateAssigmentApprovalUnit = ({ data, unitId }: IUpdateAssignmentApprovalUnitDTO) => {
	return client.put(`${attachedApprovalUnit}/${unitId}`, data);
};

export const deleteAssigmentApprovalUnit = ({ unitId }: IUnitId): Promise<void> => {
	return client.delete(`${attachedApprovalUnit}/${unitId}`);
};
